import {
  call,
  put,
  throttle,
} from 'redux-saga/effects';

import searchVacanciesAPI from '../../api/search-vacancies';
import { clearFromHTML } from '../../utils/clear-html';
import { IVacancy } from '../../utils/types/state-types';
import { receiveVacancies, rejectVacancies, requestVacancies } from '../actions/main-page';

interface ISearchVacanciesAction {
  type: string;
  payload: {
    searchValue: string;
  }
}

interface ISearchResponse {
  vacancies: IVacancy[];
  divisions: string[];
}

const searchVacancies = function* searchVacancies(action: ISearchVacanciesAction) {
  try {
    if (action.payload.searchValue) {
      const response: ISearchResponse = yield call(searchVacanciesAPI, action.payload.searchValue);
      yield put(receiveVacancies({
        vacancies: response.vacancies.map((item) => ({
          ...item,
          title: clearFromHTML(item.title),
        })),
        divisions: response.divisions,
      }));
    } else {
      yield put(receiveVacancies({
        vacancies: [],
        divisions: [],
      }));
    }
  } catch (error) {
    yield put(rejectVacancies({ error }));
  }
};

export default function* searchVacanciesWatcher() {
  yield throttle(1000, requestVacancies, searchVacancies);
}
